module.exports = __webpack_public_path__ + "img/gas2.1dbf394b.png";